import { Position } from '../models/api/vehicle-position.model';
import { first } from 'rxjs/operators';
import { Subscription, timer } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppSelector } from '../core/state/app-selector';

@Injectable({
  providedIn: 'root',
})
export class VehiclesMapService {
  googleMapSubscriptions: Map<
    string,
    { subscription: Subscription; window: Window }
  > = new Map();

  private readonly REFRESH_TIMER = 30000;

  constructor(private appSelector: AppSelector) {}

  openMap(vehicleId) {
    let subscription;
    if (this.googleMapSubscriptions[vehicleId]) {
      subscription = this.googleMapSubscriptions[vehicleId].subscription;
      delete this.googleMapSubscriptions[vehicleId].window;
    }
    if (subscription) {
      subscription.unsubscribe();
    }

    subscription = timer(0, this.REFRESH_TIMER).subscribe(() => {
      let googleMapWindow;
      if (this.googleMapSubscriptions[vehicleId]) {
        googleMapWindow = this.googleMapSubscriptions[vehicleId].window;
      }
      if (this.windowWasntClosed(googleMapWindow)) {
        this.appSelector
          .getPositions()
          .pipe(first())
          .subscribe((positions) => {
            let position = positions.find(
              (position) => position.vehicle == vehicleId
            );
            if (position) {
              googleMapWindow = this.openWindowWithMap(position);
              this.googleMapSubscriptions[vehicleId] = {
                subscription: subscription,
                window: googleMapWindow,
              };
            }
          });
      } else this.clearSubscription(googleMapWindow, subscription, vehicleId);
    });
  }

  private windowWasntClosed(googleMapWindow: any) {
    return !googleMapWindow || !googleMapWindow.closed;
  }

  public openWindowWithMap(position: Position) {
    return window.open(
      'http://maps.google.com/maps?t=k&q=' + position.lat + '+' + position.lon,
      position.name
    );
  }

  private clearSubscription(
    googleMapWindow: any,
    subscription: any,
    vehicleId: any
  ) {
    if (googleMapWindow && googleMapWindow.closed) {
      subscription.unsubscribe();
      delete this.googleMapSubscriptions[vehicleId];
    }
  }
}
